import { Rxios } from 'rxios'
import axios from 'axios'

export const rxios = new Rxios({
  baseURL: `${process.env.REACT_APP_REST_API_URL}`,
})

const { authToken } = JSON.parse(<string>sessionStorage.getItem('sparling_financial_web') ?? '1')

export const restCommon = axios.create({
  baseURL: `${process.env.REACT_APP_REST_API_URL}`,
  withCredentials: true,
  headers: {
    Authorization: `Bearer ${authToken}`,
  },
})

export const restAxios = axios.create({
  baseURL: `${process.env.REACT_APP_REST_API_URL}`,
})
